"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PROPERTIES_RESPONSE = void 0;
exports.GET_PROPERTIES_RESPONSE = {
    total: 100,
    rhsLevel: 'rhs3',
    properties: [
        {
            code: 'property-code-0',
            displayName: 'Extension - Keys',
            property: {
                pets: 1,
                bathrooms: 3,
                bedrooms: 7,
                sleeps: 6,
                adults: undefined,
                infants: undefined,
                children: undefined,
            },
            grade: '5',
            offers: [],
            location: 'Ryanborough',
            images: [
                {
                    assetId: '10842806',
                    caption: 'Interior | Streets - Ferry, Christiansenchester',
                },
            ],
            priceFrom: 745.0,
            price: 701,
            wasPrice: 820.0,
            isNewThisMonth: false,
            isFeatured: false,
            isNewlyListed: false,
            isCustomerChoice: true,
            reviewCount: 42005,
            averageReviewScore: 6,
            startDate: undefined,
            USPs: [],
            cardinality: 'SINGLE',
            features: [
                {
                    featureCode: null,
                    featureName: 'Mission',
                    featureId: '23340',
                },
                {
                    featureCode: null,
                    featureName: 'Pets Free of Charge',
                    featureId: '6554',
                },
            ],
            rhs1: 'Georgia',
            rhs2: 'Cambridgeshire',
            rhs3: 'Bedfordshire',
            rhs4: 'Buckinghamshire',
            rhs5: 'Nickbury',
        },
    ],
    aggregations: {
        features: [
            {
                featureId: '9124',
                featureName: 'Hogwarts',
                featureCode: 'AONB',
                count: 1,
            },
            {
                featureCode: null,
                featureName: 'Pets Free of Charge',
                featureId: '6554',
                count: 17648,
            },
            {
                featureId: '10390',
                featureName: 'UKONLY',
                featureCode: null,
                count: 1394,
            },
            {
                featureId: '6948',
                featureName: 'Internet Connection',
                featureCode: 'SUPER',
                count: 1292,
            },
            {
                featureId: '10408',
                featureName: 'Parking-designated on site',
                featureCode: null,
                count: 1245,
            },
            {
                featureId: '9174',
                featureName: 'Linen Available',
                featureCode: null,
                count: 1229,
            },
            {
                featureId: '6833',
                featureName: 'Guide Pet',
                featureCode: null,
                count: 1212,
            },
            {
                featureId: '9183',
                featureName: 'Shower',
                featureCode: null,
                count: 1210,
            },
            {
                featureId: '6725',
                featureName: 'Television',
                featureCode: null,
                count: 1208,
            },
            {
                featureId: '6906',
                featureName: 'Closeout period',
                featureCode: null,
                count: 1156,
            },
            {
                featureId: '9181',
                featureName: 'Washing Machine',
                featureCode: null,
                count: 1145,
            },
            {
                featureId: '11290',
                featureName: '4 nights for 3',
                featureCode: null,
                count: 1135,
            },
            {
                featureId: '10091',
                featureName: 'Coastal within 5 miles',
                featureCode: null,
                count: 1107,
            },
            {
                featureId: '9281',
                featureName: 'Coastal',
                featureCode: 'SUPER',
                count: 1102,
            },
            {
                featureId: '9176',
                featureName: 'Linen options',
                featureCode: null,
                count: 1084,
            },
            {
                featureId: '6959',
                featureName: 'Linen',
                featureCode: null,
                count: 1067,
            },
            {
                featureId: '6401',
                featureName: 'Garden / Patio',
                featureCode: null,
                count: 1051,
            },
            {
                featureId: '6107',
                featureName: 'Grade',
                featureCode: null,
                count: 979,
            },
            {
                featureId: '6311',
                featureName: 'Fuel and Power Included',
                featureCode: null,
                count: 970,
            },
            {
                featureId: '10090',
                featureName: 'Coastal within 3 miles',
                featureCode: null,
                count: 963,
            },
            {
                featureId: '6275',
                featureName: 'Dishwasher',
                featureCode: null,
                count: 917,
            },
            {
                featureId: '12022',
                featureName: '1GrpB',
                featureCode: null,
                count: 912,
            },
            {
                featureId: '12024',
                featureName: '1GrpH',
                featureCode: null,
                count: 912,
            },
            {
                featureId: '6455',
                featureName: 'Pub within 1 mile',
                featureCode: null,
                count: 892,
            },
            {
                featureId: '6491',
                featureName: 'Close to Beach',
                featureCode: null,
                count: 876,
            },
            {
                featureId: '6101',
                featureName: 'Close to Sea',
                featureCode: null,
                count: 837,
            },
            {
                featureId: '8821',
                featureName: 'Cot Available',
                featureCode: null,
                count: 823,
            },
            {
                featureId: '9138',
                featureName: 'Yorkshire Moors',
                featureCode: null,
                count: 800,
            },
        ],
        grades: [
            { grade: '4', count: 988 },
            { grade: '3', count: 213 },
            { grade: '5', count: 205 },
            { grade: 'P', count: 6 },
            { grade: '2', count: 2 },
        ],
        bathrooms: [
            { bathrooms: 1, count: 816 },
            { bathrooms: 2, count: 463 },
            { bathrooms: 3, count: 104 },
            { bathrooms: 4, count: 24 },
            { bathrooms: 5, count: 4 },
            { bathrooms: 6, count: 2 },
            { bathrooms: 7, count: 1 },
        ],
        bedrooms: [
            { bedrooms: 2, count: 601 },
            { bedrooms: 3, count: 359 },
            { bedrooms: 1, count: 307 },
            { bedrooms: 4, count: 99 },
            { bedrooms: 5, count: 24 },
            { bedrooms: 6, count: 9 },
            { bedrooms: 0, count: 8 },
            { bedrooms: 7, count: 4 },
            { bedrooms: 8, count: 3 },
        ],
        regions: {
            rhs1: [{ region: 'England', count: 1414, id: 21667 }],
            rhs2: [{ region: 'South West England', count: 1414, id: 21996 }],
            rhs3: [{ region: 'Cornwall', count: 1414, id: 22070 }],
            rhs4: [
                { region: 'North Cornwall', count: 653, id: 22071 },
                { region: 'South Cornwall', count: 552, id: 22085 },
                { region: 'West Cornwall', count: 209, id: 22097 },
            ],
            rhs5: [
                { region: 'Bude', count: 136, id: 22074 },
                { region: 'Newquay', count: 133, id: 22077 },
                { region: 'Fowey', count: 73, id: 22088 },
                { region: 'Looe', count: 72, id: 22090 },
                { region: 'Liskeard', count: 65, id: 22089 },
                { region: 'Padstow', count: 61, id: 22078 },
                { region: 'Port Isaac', count: 59, id: 22080 },
                {
                    region: 'Callington and the Tamar Valley',
                    count: 53,
                    id: 22086,
                },
                { region: 'Falmouth', count: 53, id: 22087 },
                { region: 'St Austell', count: 48, id: 22094 },
                { region: 'Mevagissey', count: 47, id: 22092 },
                { region: 'Polperro', count: 44, id: 23596 },
                { region: 'St Ives', count: 44, id: 22103 },
                { region: 'Launceston', count: 35, id: 22076 },
                { region: 'St Columb Major', count: 35, id: 22083 },
                { region: 'Porthtowan', count: 34, id: 23652 },
                { region: 'Camelford', count: 33, id: 22075 },
                { region: 'St Just', count: 29, id: 22104 },
                { region: 'Hayle', count: 28, id: 23534 },
                {
                    region: 'Helston and the Lizard Peninsula',
                    count: 27,
                    id: 22098,
                },
                { region: 'Marazion', count: 27, id: 22099 },
                { region: 'Bodmin', count: 26, id: 22072 },
                { region: 'Penzance', count: 19, id: 22101 },
                { region: 'Perranporth', count: 19, id: 22079 },
                { region: 'Tintagel', count: 19, id: 22084 },
                { region: 'Mawgan Porth', count: 18, id: 23838 },
                { region: 'Wadebridge', count: 18, id: 23595 },
                { region: 'Crackington Haven', count: 17, id: 23630 },
                { region: 'Mousehole and Newlyn', count: 17, id: 22100 },
                { region: 'Boscastle', count: 15, id: 22073 },
                { region: 'Lostwithiel', count: 13, id: 22091 },
                { region: 'Portreath', count: 13, id: 22081 },
                { region: 'Charlestown and Duporth', count: 11, id: 23832 },
                { region: 'Sennen', count: 11, id: 22102 },
                { region: 'St Breock', count: 11, id: 23829 },
                { region: 'Downderry', count: 8, id: 23881 },
                { region: 'St Agnes', count: 7, id: 23593 },
                { region: 'Torpoint and Wilcove', count: 7, id: 23837 },
                {
                    region: 'Truro and the Roseland Peninsula',
                    count: 6,
                    id: 22096,
                },
                { region: 'Porthcurno', count: 5, id: 23864 },
                { region: 'Saltash', count: 5, id: 22093 },
                { region: 'Watergate Bay', count: 4, id: 23880 },
                { region: 'Kingsand and Cawsand', count: 3, id: 22095 },
                { region: 'Portwrinkle', count: 3, id: 23862 },
                { region: 'Praa Sands', count: 2, id: 23865 },
                { region: 'Polzeath', count: 1, id: 23863 },
            ],
        },
        reviews: [
            { score: 0, count: 0 },
            { score: 1, count: 3 },
            { score: 2, count: 2 },
            { score: 3, count: 2 },
            { score: 4, count: 5 },
            { score: 5, count: 13 },
            { score: 6, count: 25 },
            { score: 7, count: 76 },
            { score: 8, count: 275 },
            { score: 9, count: 606 },
            { score: 10, count: 142 },
        ],
    },
};
//# sourceMappingURL=getPropertiesResponse.js.map